import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

export const basicAuthGuard: CanActivateFn = () => {
  const router = inject(Router);  // Inject router for navigation

  // Check if BasicAuth is enabled in environment settings
  if (environment.isBasicAuth) {
    // Check if the user has a valid token in localStorage
    const token = localStorage.getItem('authToken');
    if (token) {
      return true;  // User is authenticated, allow route access
    } else {
      // Redirect to login if not authenticated
      router.navigate(['/login']);
      return false;
    }
  }
  return true;  // If BasicAuth is not enabled, allow route access
};
